import { clearFiltersSearch } from '@api/mapView/clearFiltersSearch';
import { useAppSelector } from '@redux/hooks';
import { Logger } from '@utils/logger/logger';
import { useMap } from '@vis.gl/react-google-maps';
import { type Dispatch, type SetStateAction, useCallback } from 'react';

const useClearedSearch = (
	setFilteredVendors: Dispatch<SetStateAction<Vendor.Raw[]>>,
) => {
	const categoryGuid = useAppSelector((state) => state.category.id);
	const location = useAppSelector((state) => state.location);
	const page = useAppSelector((state) => state.search.pagination.page);
	const map = useMap();

	const handleClearedSearch = useCallback(async () => {
		const zeroIndexBasedPage = page > 0 ? page - 1 : 0;
		try {
			const searchResponse = await clearFiltersSearch({
				categoryGuid,
				filters: [categoryGuid],
				location,
				map,
				page: zeroIndexBasedPage,
			});
			if (searchResponse?.data?.search?.profiles) {
				setFilteredVendors(searchResponse.data.search.profiles);
			}
		} catch (error) {
			Logger.error({
				log_message:
					'useClearedSearch hook failed: Error searching with bounding box',
				errorToLog: error,
				newRelic: true,
			});
		}
	}, [categoryGuid, location, map, page, setFilteredVendors]);

	return useCallback(() => {
		handleClearedSearch();
	}, [handleClearedSearch]);
};

export { useClearedSearch };
